// composables/usePortal.js
export const usePortal = () => {
    const fetchPortal = async () => {

      const { $pb } = useNuxtApp();
      const token = $pb.authStore.token;
  
      return await $fetch('/api/portal', {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    };
  
    return {
      fetchPortal,
    };
};
  